/** Flattens FireCMS/Yup map field errors into a single string for display. */
export function formatFieldError(error: unknown): string | undefined {
  if (!error) {
    return undefined;
  }

  if (typeof error === "string") {
    return error;
  }

  if (typeof error === "object") {
    const messages = Object.values(error as Record<string, unknown>).filter(
      (value): value is string => typeof value === "string" && value.length > 0
    );

    return messages.length > 0 ? messages.join(" · ") : undefined;
  }

  return undefined;
}
